import {
  CircleEllipsis,
  Instagram,
  MapPin,
  MessageCircleQuestion,
  Phone,
  Speech,
} from "lucide-react";
import servicePageImage1 from "./images/service/training.webp";
import servicePageImage2 from "./images/service/service-dog.webp";
import servicePageImage3 from "./images/service/service.webp";

export const APP_NAME = "DWL K9";

export const APP_URL = "https://dogwhisperersk9.com/";

export const APP_PHONE = "+2349033999464";

export const COMPANY_ADDRESS = "58c Bank Olemoh Street, Surulere, Lagos.";

export const HEADER_LINKS = [
  {
    link: "/about",
    text: "About Us",
  },
  {
    link: "/services",
    text: "Our Services",
  },
  {
    link: "/contact",
    text: "Contact Us",
  },
];

export const COMMITMENT_LIST = [
  {
    title: "Train exceptional dogs",
    text: "Offer comprehensive training programs to help dogs become well-behaved companions, skilled working animals, and valuable assets to their communities.",
  },
  {
    title: "Educate owners",
    text: "Provide expert guidance and support to dog owners, empowering them to create strong, positive relationships with their pets.",
  },
  {
    title: "Serve the community",
    text: "Contribute to the well-being of our community by providing highly trained service animals and supporting law enforcement and public safety initiatives.",
  },
];

export const SERVICES_CHECKLIST = [
  {
    name: "Dog Training",
    services: [
      {
        title: "Obedience training",
        text: "Basic and advanced obedience commands (sit, stay, come, heel, etc.)",
      },
      {
        title: "Behavior modification",
        text: "Addressing problem behaviors such as barking, jumping, aggression, and separation anxiety.",
      },
      {
        title: "Off-leash training",
        text: "Teaching dogs to be reliable off-leash companions.",
      },
      {
        title: "Agility training",
        text: "Developing dogs' athletic abilities and agility skills.",
      },
    ],
  },
  {
    name: "Specialized Training",
    services: [
      {
        title: "Police dog training",
        text: " Training dogs for law enforcement purposes, including patrol, search and rescue, and drug/explosive detection.",
      },
      {
        title: "Service dog training",
        text: "Training dogs to assist individuals with disabilities.",
      },
      {
        title: "Protection dog training",
        text: "Training dogs to protect their owners and property.",
      },
      {
        title: "Narcotics and Explosive detection training",
        text: "Training dogs to possess an extraordinary ability to detect illegal substances and explosives, making them invaluable assets to law enforcement agencies, customs officials, and security personnel worldwide.",
      },
    ],
  },
  {
    name: "Additional Services",
    services: [
      {
        title: "Boarding and daycare",
        text: "Providing safe and comfortable accommodations for dogs when their owners are away.",
      },
      {
        title: "Grooming",
        text: "Offering professional grooming services, including bathing, brushing, nail trimming, and ear cleaning.",
      },
      {
        title: "Consulting",
        text: "Providing expert advice and consultation on dog care, training, and behavior.",
      },
    ],
  },
];

export const FOOTER_LINKS = [
  {
    title: "Learn More",
    links: [
      { text: "About Us", href: "/about" },
      { text: "Contact", href: "/contact" },
      { text: "Services", href: "/services" },
    ],
    icons: [<MessageCircleQuestion />, <Speech />, <CircleEllipsis />],
  },
  {
    title: "Socials",
    links: [
      {
        text: "Instagram",
        href: "https://www.instagram.com/dwlk9ng/",
      },
      {
        text: "Over the Phone ?",
        href: "tel:+2349033999464",
      },
    ],
    icons: [<Instagram />, <Phone />],
  },
];

export const CONTACT_DETAILS = [
  {
    title: "Location",
    text: COMPANY_ADDRESS,
    href: "https://maps.app.goo.gl/w3b4Me3hCqHoyyXk8",
    icons: <MapPin size={40} />,
  },
  {
    title: "Instagram",
    text: "@dwlk9ng",
    href: "https://www.instagram.com/dwlk9ng/",
    icons: <Instagram size={40} />,
  },
  {
    title: "Over the Phone ?",
    text: APP_PHONE,
    href: "tel:" + APP_PHONE,
    icons: <Phone size={40} />,
  },
];

export const SERVICE_PAGE_SERVICES = [
  {
    title: "Police Dog Training",
    description:
      "Police dog training involves selecting suitable dogs based on physical attributes, temperament, and prey drive; teaching them basic obedience commands like sit, stay, come, and heel; and providing specialized training for tasks such as patrol, search and rescue, drug detection, and explosive detection, with certification following the completion of their training.",
    image: servicePageImage1,
  },
  {
    title: "Service Dog Training",
    description:
      "Service dogs are trained to assist individuals with disabilities by performing tasks such as guiding, retrieving, alerting, and providing physical assistance, with the training process involving the careful selection of dogs based on temperament and suitability, teaching basic obedience and specific role-related tasks, training them for appropriate behavior in public settings, and finally certifying them as service dogs by a recognized organization.",
    image: servicePageImage2,
  },
  {
    title: "Narcotics and Explosive Detection Dog training",
    description:
      "Narcotics Detection Dogs (NDDs) and Explosive Detection Dogs (EDDs) are highly trained canines that play a crucial role in public safety. These specialized dogs possess an extraordinary ability to detect illegal substances and explosives, making them invaluable assets to law enforcement agencies, customs officials, and security personnel worldwide. NDDs can be deployed in airports, seaports, border crossings, and other high-risk areas to prevent the trafficking of illegal drugs. EDDs can quickly and efficiently scan large areas for hidden explosives, helping to prevent terrorist attacks and ensure public safety. This training play a vital role in combating crime, terrorism, and drug trafficking. They help to protect public safety, prevent the spread of illegal substances, and deter criminal activity. These specialized dogs are a valuable asset to law enforcement agencies and security personnel around the world.",
    image: servicePageImage3,
  },
];
